module.exports = {
    presenceEditAction(action) {
        document.dispatchEvent(new CustomEvent('presenceEdit', { detail: { action } }));
    }
};
